import { useContext } from 'react';

import { Route, Routes } from 'react-router-dom';

import { useStore } from '../../domain/users/store';

import { Private_Routes } from '../constants';

import { ProfilePage } from '../../ui/user/profile/pages';

import { HomePage } from '../../ui/home/page/HomePage';
import { AppContext } from '../context/Provider';
import Breadcrumb from './Breadcrumb';
import Footer from './Footer';
import Header from './Header';
import { EmployeePage } from '../../ui/employees/pages/EmployeePage';
import { CreateEmployeePage } from '../../ui/employees/pages/CreateEmployeePage';
import { CustomerPage } from '../../ui/customers/pages/CustomerPage';
import { CreateCustomerPage } from '../../ui/customers/pages/CreateCustomerPage';
import { UpdateEmployeePage } from '../../ui/employees/pages/UpdateEmployeePage';
import { UpdateCustomerPage } from '../../ui/customers/pages/UpdateCustomerPage';
import { ProjectPage } from '../../ui/projects/pages/ProjectPage';
import { CreateProjectPage } from '../../ui/projects/pages/CreateProjectPage';
import { UpdateProjectPage } from '../../ui/projects/pages/UpdateProjectPage';
import { ContactPage } from '../../ui/customer-contacts/pages/ContactPage';
import { CreateContactPage } from '../../ui/customer-contacts/pages/CreateContactPage';
import { UpdateContactPage } from '../../ui/customer-contacts/pages/UpdateContactPage';
import { ProjectOverviewPage } from '../../ui/projects/pages/ProjectOverviewPage';
import { CreateProjectCheckpointPage } from '../../ui/projects/pages/CreateProjectCheckpointPage';
import { ProjectStatusPage } from '../../ui/project-status/pages/ProjectStatusPage';
import { CreateProjectStatusPage } from '../../ui/project-status/pages/CreateProjectStatusPage';
import { UpdateProjectStatusPage } from '../../ui/project-status/pages/UpdateProjectStatusPage';
import { ProjectMilestonePage } from '../../ui/project-milestones/pages/ProjectMilestonePage';
import { CreateProjectMilestonePage } from '../../ui/project-milestones/pages/CreateProjectMilestonePage';
import { UpdateProjectMilestonePage } from '../../ui/project-milestones/pages/UpdateProjectMilestonePage';

const AuthRouter = () => {
    const { nestedRoutes } = useContext(AppContext);

    const { commonStore } = useStore();

    return (
        <div id='layout-wrapper'>
            <Header />
            <div className='vertical-overlay'></div>
            <div className='main-content'>
                <div className='page-content'>
                    <div className='container-fluid main'>
                        <div className='row'>
                            <div
                                className=' mb-3 d-flex justify-content-between align-items-center '
                                style={{
                                    backgroundColor: '#FFFF',
                                }}
                            >
                                <Breadcrumb nestedRoutes={nestedRoutes} />
                            </div>

                            <div
                                className='p-1 py-3'
                                style={{
                                    backgroundColor: '#FFFF',
                                }}
                            >
                                <Routes>
                                    <Route
                                        path={Private_Routes.HOME}
                                        element={<HomePage />}
                                    />

                                    <Route
                                        path={Private_Routes.EMPLOYEE_PAGE}
                                        element={<EmployeePage />}
                                    />
                                    <Route
                                        path={Private_Routes.CREATE_EMPLOYEE_PAGE}
                                        element={<CreateEmployeePage />}
                                    />
                                    <Route
                                        path={Private_Routes.UPDATE_EMPLOYEE_PAGE}
                                        element={<UpdateEmployeePage />}
                                    />

                                    <Route
                                        path={Private_Routes.CUSTOMER_PAGE}
                                        element={<CustomerPage />}
                                    />
                                    <Route
                                        path={Private_Routes.CREATE_CUSTOMER}
                                        element={<CreateCustomerPage />}
                                    />
                                    <Route
                                        path={Private_Routes.UPDATE_CUSTOMER}
                                        element={<UpdateCustomerPage />}
                                    />
                                    <Route
                                        path={Private_Routes.PROJECT_PAGE}
                                        element={<ProjectPage />}
                                    />
                                    <Route
                                        path={Private_Routes.CREATE_PROJECT}
                                        element={<CreateProjectPage />}
                                    />
                                    <Route
                                        path={Private_Routes.UPDATE_PROJECT}
                                        element={<UpdateProjectPage />}
                                    />
                                    <Route
                                        path={Private_Routes.CONTACTS_PAGE}
                                        element={<ContactPage />}
                                    />
                                    <Route
                                        path={Private_Routes.CREATE_CONTACT}
                                        element={<CreateContactPage />}
                                    />
                                    <Route
                                        path={Private_Routes.UPDATE_CONTACT}
                                        element={<UpdateContactPage />}
                                    />
                                    <Route
                                        path={Private_Routes.OVERVIEW_PROJECT}
                                        element={<ProjectOverviewPage />}
                                    />
                                    <Route
                                        path={
                                            Private_Routes.CREATE_PROJECT_CHECKPOINTS_PAGE
                                        }
                                        element={<CreateProjectCheckpointPage />}
                                    />
                                    <Route
                                        path={Private_Routes.PROJECT_STATUS_PAGE}
                                        element={<ProjectStatusPage />}
                                    />
                                    <Route
                                        path={Private_Routes.CREATE_PROJECT_STATUS}
                                        element={<CreateProjectStatusPage />}
                                    />
                                    <Route
                                        path={Private_Routes.UPDATE_PROJECT_STATUS}
                                        element={<UpdateProjectStatusPage />}
                                    />
                                    <Route
                                        path={Private_Routes.PROJECT_MILESTONE_PAGE}
                                        element={<ProjectMilestonePage />}
                                    />
                                    <Route
                                        path={
                                            Private_Routes.CREATE_PROJECT_MILESTONE
                                        }
                                        element={<CreateProjectMilestonePage />}
                                    />
                                    <Route
                                        path={
                                            Private_Routes.UPDATE_PROJECT_MILESTONE
                                        }
                                        element={<UpdateProjectMilestonePage />}
                                    />
                                    <Route
                                        path={Private_Routes.PROFILE}
                                        element={<ProfilePage />}
                                    />
                                </Routes>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </div>
    );
};

export default AuthRouter;
